var app = app ||  {};
app.projetos = app.projetos || {};

;(function(namespace, $){

  var Projetos = function() {

    function CadastraUsuario() {
      var validate_form = new lcssafira.form.ValidateForm('form-user');
    }

    function _construct() {
      CadastraUsuario();

      var message = "A remoção de um usuário implica na exclusão de qualquer dado vinculado a ele.";
      var confirm_modal = new lcssafira.confirmmodal.ConfirmModal('.remove-usuario', message);
    }

    _construct();

  };

  var main = new Projetos();

})(app.projetos, jQuery);


